import React, { useState } from 'react';
import styles from './menu.module.scss';
import MenuImage from 'assets/images/menu-image.png';
import MenuImageSp from 'assets/images/menu-image-sp.png';
import MecLogo from 'assets/images/mec-logo.webp';
import { Link } from 'react-router-dom';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
import classNames from 'classnames';

export const Menu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuLink = () => {
    setIsOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <button
        className={`${styles.menuButton} ${isOpen ? styles.open : ''}`}
        onClick={toggleMenu}
        aria-label="メニュー"
      >
        <span className={styles.menuIcon}></span>
      </button>
      <div className={`${styles.menuOverlay} ${isOpen ? styles.open : ''}`}>
        <div className={styles.menuContent}>
          <div className={styles.logoBlock}>
            <Link to={'/#top'} className={styles.logoText} onClick={handleMenuLink}>
              ペットライフサポート プロジェクト
            </Link>
            <img className={classNames(styles.mecLogo, styles.spOnly)} src={MecLogo} alt="三菱地所" />
          </div>
          <div className={styles.menuNav}>
            <ul>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} onClick={handleMenuLink} to="/">
                  <div className={styles.menuLinkInner}>
                    <p>TOPページ</p>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} onClick={handleMenuLink} to="/news-list">
                  <div className={styles.menuLinkInner}>
                    <p>お知らせ</p>
                    <span>サポーター特典やペットライフサポート物件の情報</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} onClick={handleMenuLink} to="/worries">
                  <div className={styles.menuLinkInner}>
                    <p>ペットとペットオーナーの悩み</p>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} onClick={handleMenuLink} to="/about">
                  <div className={styles.menuLinkInner}>
                    <p>真の“ペットと人の共生”マンションとは</p>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} onClick={handleMenuLink} to="/p-man-comic">
                  <div className={styles.menuLinkInner}>
                    <p>皆さまの4コマ劇場</p>
                    <span>4コマ漫画でわかるペットライフ</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} onClick={handleMenuLink} to="/supporters-voice">
                  <div className={styles.menuLinkInner}>
                    <p>SUPPORTER’S VOICE＆PHOTO</p>
                    <span>サポーターの皆さまの声とペットのお写真</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} onClick={handleMenuLink} to="/faq">
                  <div className={styles.menuLinkInner}>
                    <p>FAQ</p>
                    <span>よくある質問</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
            </ul>
            <p className={styles.menuFooter}>本件は事業化検討段階のため内容が<br className={styles.spOnly} />変更となる場合があります</p>
          </div>
          <img
            src={MenuImage}
            alt="メニュー画像"
            className={classNames(styles.menuImage, styles.pcOnly)}
          />
          <img
            src={MenuImageSp}
            alt="メニュー画像"
            className={classNames(styles.menuImage, styles.spOnly)}
          />
        </div>
      </div>
    </>
  );
};

export default Menu; 